export default __webpack_public_path__ + "static/media/icon_google_firebase.a5244d30.svg";